export default __webpack_public_path__ + "static/media/carrosel01.a2af3f6c.png";